export default "__VITE_PUBLIC_ASSET__a44c795b__"